import request from 'utils/request'
import { LENGJ_HEADERS } from '@/config/lengj-index'

// 监控企业失信信息接口
export const getMonitorEnterpriseDiscreditInfo = data =>
  request().post(
    'riskraider/v3.1/blacklist/getEnterpriseDiscreditInformation',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
